import Button from "components/components/Button/Button";
import InfoBox from "components/components/InfoBox/InfoBox";
import { RequestStatus } from "hooks/useRequest";
import React from "react";

import {
  InfoBoxContainer,
  LandingSection,
  RequestCredentialsButtonContainer,
  SubsectionHeader,
} from "./style";

type Props = {
  requestCredentials: () => Promise<void>;
  requestStatus: RequestStatus;
};

const RemitApiCredentialsLanding: React.FC<Props> = ({
  requestCredentials,
  requestStatus,
}) => {
  const isRequestInProgress = requestStatus === RequestStatus.IN_PROGRESS;

  return (
    <LandingSection>
      <SubsectionHeader>Submit a REMIT Notification via API</SubsectionHeader>
      <p>
        You can submit REMIT notifications programmatically using the Insights
        API. To get started, request your API credentials below. Once generated,
        use them to authenticate requests to the REMIT endpoint.
      </p>
      <InfoBoxContainer>
        <InfoBox
          title="You don't have any API credentials yet"
          description="Request credentials to start submitting REMIT notifications via API."
        />
      </InfoBoxContainer>
      <RequestCredentialsButtonContainer>
        <Button
          buttonText="Request credentials"
          onClick={requestCredentials}
          disabled={isRequestInProgress}
          className={isRequestInProgress ? "loading" : undefined}
        />
      </RequestCredentialsButtonContainer>
      <div role="status" aria-live="polite">
        {isRequestInProgress ? "Requesting credentials." : null}
      </div>
    </LandingSection>
  );
};

export default RemitApiCredentialsLanding;
